import React, { useEffect, useMemo, useState } from "react";
import classes from "./Investigation.module.css";
import CircleOutlinedIcon from "@mui/icons-material/CircleOutlined";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import {
  Checkbox,
  FormGroup,
  FormControlLabel,
  FormControl,
  Typography,
} from "@mui/material";

const InvestigationAssignedBlock = ({
  isCheckbox = true,
  ApprovalInvestigationAssignedBlocks = [],
  InvestigationAssignedBlockClickHandler = () => {},
  InvestigatorTabDetails = [],
}) => {
  const assignedLabels = useMemo(() => {
    return InvestigatorTabDetails.map((blockId) => {
      const block = ApprovalInvestigationAssignedBlocks.find(
        (item) => item?.id === blockId?.id
      );
      return block ? { ...block, checked: blockId?.checked } : "";
    });
  }, [InvestigatorTabDetails, ApprovalInvestigationAssignedBlocks]);

  // const assignedLabels = Object.values(InvestigatorTabDetails).map(
  //   (blockId) => {
  //     const block = ApprovalInvestigationAssignedBlocks.find(
  //       (item) => item?.id === blockId
  //     );
  //     return block ? block : "";
  //   }
  // );

  return (
    <>
      <Typography className={classes["investigation-assigned-blocks-heading"]}>
        Assigned Blocks
      </Typography>
      <div className={classes["investigation-assigned-blocks"]}>
        {assignedLabels?.map((item) => {
          return (
            <FormControl
              component="fieldset"
              className={classes["investigation-assigned-blocks-elements"]}
            >
              <FormGroup
                aria-label="position"
                row
                sx={{
                  "& .MuiFormControlLabel-root": {
                    margin: 0,
                    paddingLeft: "1rem",
                  },
                }}
              >
                <FormControlLabel
                  sx={{
                    padding: !isCheckbox ? "0.9rem 0.8rem" : "unset",
                  }}
                  value={item?.label}
                  control={
                    <Checkbox
                      sx={{ display: !isCheckbox ? "none" : "inline-block" }}
                      id={item?.id}
                      checked={item?.checked}
                      onChange={InvestigationAssignedBlockClickHandler}
                      icon={<CircleOutlinedIcon sx={{ color: "#F4A6A8" }} />}
                      checkedIcon={
                        <RadioButtonCheckedIcon sx={{ color: "#E42125" }} />
                      }
                    />
                  }
                  label={item?.label}
                  labelPlacement="start"
                />
              </FormGroup>
            </FormControl>
          );
        })}
      </div>
    </>
  );
};

export default InvestigationAssignedBlock;
